import type { IconName } from "@/components/ui/icon";

export interface NotificationCategory {
  id: string;
  label: string;
  description: string;
  icon: IconName;
  defaultInArbi: boolean;
  defaultEmail: boolean;
}

export const NOTIFICATION_CATEGORIES = [
  {
    id: "mentions",
    label: "Mentions",
    description: "Notify me when someone mentions me.",
    icon: "IconBubbleWideNotification",
    defaultInArbi: true,
    defaultEmail: false,
  },
  {
    id: "replies",
    label: "Replies",
    description: "Notify me when someone replies to me.",
    icon: "IconBubble5",
    defaultInArbi: true,
    defaultEmail: false,
  },
  {
    id: "sequence_replies",
    label: "Sequence replies",
    description:
      "Notify me when a candidate replies to one of my outreach sequences.",
    icon: "IconBubbleDots",
    defaultInArbi: true,
    defaultEmail: true,
  },
  {
    id: "exports",
    label: "Exports",
    description: "Notify me when an export I started finishes.",
    icon: "IconArrowInbox",
    defaultInArbi: true,
    defaultEmail: false,
  },
] satisfies NotificationCategory[];

export const PERSONAL_TOAST_CATEGORIES = new Set([
  "mentions",
  "replies",
  "sequence_replies",
]);
